import React from 'react';
import { TitleBar } from '@shopify/app-bridge-react';
import { Page, Card, AppProvider, Frame, Stack, Icon, TextStyle, Heading } from '@shopify/polaris';
import {
  EmailMajorMonotone,
  SettingsMajorMonotone,
  BillingStatementDollarMajorMonotone,
  BlogMajorMonotone,
  JobsMajorMonotone,
  NotificationMajorMonotone,
  TeamMajorMonotone,
  LocationMajorMonotone,
  AutomationMajorMonotone
} from '@shopify/polaris-icons';
import Footer from './Footer';

const GoogleMajorMonotone = () => {
  return (
    <svg
      width='1254.000000pt'
      height='1280.000000pt'
      viewBox='0 0 1254.000000 1280.000000'
      preserveAspectRatio='xMidYMid meet'
      xmlns='http://www.w3.org/2000/svg'>
      <g transform='translate(0.000000,1280.000000) scale(0.100000,-0.100000)' fill='rgb(140 145 150)' stroke='none'>
        <path
          d='M6100 12794 c-1179 -64 -2247 -411 -3205 -1041 -917 -604 -1664
-1429 -2171 -2398 -1003 -1919 -958 -4257 121 -6135 948 -1652 2600 -2811
4450 -3124 414 -70 656 -90 1115 -90 374 0 507 7 800 40 1266 143 2338 586
3250 1342 150 125 529 504 656 658 816 983 1273 2148 1401 3574 21 243 24 946
5 1170 -24 272 -57 540 -88 719 -8 46 -14 85 -14 87 0 2 -1354 4 -3010 4
l-3010 0 0 -1250 0 -1250 1740 0 c1173 0 1740 -3 1740 -10 0 -24 -45 -215 -76
-320 -150 -520 -472 -1030 -873 -1387 -469 -418 -1106 -707 -1811 -822 -451
-73 -980 -74 -1378 -1 -1074 198 -2039 877 -2615 1840 -135 226 -296 578 -346
758 -10 37 -35 123 -55 192 -102 350 -141 641 -141 1055 0 293 7 382 46 620
114 704 423 1367 895 1920 647 760 1525 1227 2499 1330 164 17 583 20 736 5
806 -80 1463 -368 2067 -906 l53 -48 757 755 c416 415 785 781 819 812 34 31
96 98 138 148 l76 90 -33 39 c-18 22 -46 56 -62 75 -16 20 -49 48 -75 62 -25
15 -93 66 -151 113 -668 551 -1482 960 -2347 1179 -358 90 -640 138 -1038 177
-142 13 -725 26 -865 18z'
        />
      </g>
    </svg>
  );
};

const SettingsItem = (props) => {
  const { title, description, icon, onClick } = { ...props };
  return (
    <div className={'settings-grid-item'} onClick={onClick}>
      <div className={'settings-grid-icon-container'}>
        <Icon source={icon} color={'subdued'} backdrop />
      </div>
      <Stack vertical spacing={'extraTight'}>
        <div className={'settings-grid-item-title'}>
          <Heading>{title}</Heading>
        </div>
        <TextStyle variation={'subdued'}>{description}</TextStyle>
      </Stack>
    </div>
  );
};

const SettingsIndex = (props) => {
  const { history = {} } = { ...props };
  const { push: changeRoute = () => {} } = { ...history };
  return (
    <AppProvider>
      <Frame>
        <TitleBar title={'Settings'} onAction={() => { changeRoute('/settings'); }} />
        <Page title={'Settings'}>
          <Card sectioned>
            <Card.Section>
              <div className={'settings-grid-container'}>
                <SettingsItem
                  title={'General'}
                  description={'View and update your company details'}
                  icon={SettingsMajorMonotone}
                  onClick={() => changeRoute('/settings/general')}
                />
                <SettingsItem
                  title={'Account plan'}
                  description={'Manage your account plan and subscription'}
                  icon={BillingStatementDollarMajorMonotone}
                  onClick={() => changeRoute('/settings/account-plan')}
                />
                <SettingsItem
                  title={'Google for Jobs'}
                  description={'Post your jobs to Google for Jobs'}
                  icon={GoogleMajorMonotone}
                  onClick={() => changeRoute('/google-settings')}
                />
                <SettingsItem
                  title={'Email templates'}
                  description={'Customize email templates sent to your candidates'}
                  icon={EmailMajorMonotone}
                  onClick={() => changeRoute('/settings/templates/email')}
                />
                <SettingsItem
                  title={'Questionnaire templates'}
                  description={'Create and manage automated questionnaires sent to candidates'}
                  icon={BlogMajorMonotone}
                  onClick={() => changeRoute('/settings/templates/questionnaires')}
                />
                <SettingsItem
                  title={'Job templates'}
                  description={'View and update job description templates'}
                  icon={JobsMajorMonotone}
                  onClick={() => changeRoute('/settings/templates/job-descriptions')}
                />
                <SettingsItem
                  title={'Hiring locations'}
                  description={'Manage the places you company will be hiring new employees'}
                  icon={LocationMajorMonotone}
                  onClick={() => changeRoute('/settings/hiring-locations')}
                />
                <SettingsItem
                  title={'Hiring team'}
                  description={'Add team members to your account'}
                  icon={TeamMajorMonotone}
                  onClick={() => changeRoute('/settings/hiring-team')}
                />
                <SettingsItem
                  title={'Notifications'}
                  description={'Manage notifications sent to your team'}
                  icon={NotificationMajorMonotone}
                  onClick={() => changeRoute('/settings/notifications')}
                />
                <SettingsItem
                  title={'Zapier'}
                  description={'Automate your hiring workflows by connecting ShopHire to your favorite apps'}
                  icon={AutomationMajorMonotone}
                  onClick={() => window.open('https://zapier.com/apps/shophire-ca119476/integrations')}
                />
              </div>
            </Card.Section>
          </Card>
          <Footer link='https://help.shophire.co/article/8-settings' name='Settings' />
        </Page>
      </Frame>
    </AppProvider>
  );
};

export default SettingsIndex;
